import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Loader } from './Loader';
import { useTranslation } from 'react-i18next';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',

    height: '100%',
    width: '100%',
    flex: 1,
  },
  message: {
    ...theme.fonts.h5,
  },
}));

interface Props {
  className?: string;
  message?: string;
  noMessage?: boolean;
}

export const CenteredLoader = (props: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation('common');

  return (
    <div className={classnames(classes.container, props.className)}>
      <Loader />
      {(props.message || !props.noMessage) && (
        <div className={classes.message}>{props.message || t('loading')}</div>
      )}
    </div>
  );
};
